import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    const initializeHashcash = () => {
      if (typeof Hashcash !== 'undefined') {
        this.produceHashcash()
        clearInterval(this.hashcashInterval)
      }
    }

    this.hashcashInterval = setInterval(initializeHashcash, 100)
  }

  produceHashcash () {
    this.hashcashInstance = new Hashcash(this.element)
  }

  disconnect () {
    clearInterval(this.hashcashInterval)
  }
}
